<template>
  <v-dialog v-model="dialog" scrollable max-width="900px" persistent>
    <v-form v-model="isValid" ref="form">
      <v-card>
        <v-toolbar color="white" fixed>
          <h3>{{ label }}</h3>
        </v-toolbar>
        <v-card-text>
          <v-container dense>
            <v-row>
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  v-model="tariffCategory.name"
                  :label="$i18n.t('Name') + '*'"
                  :rules="validationrules.name"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <small>*indicates required field</small>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeDialog">Close</v-btn>
          <v-btn
            color="success darken-1"
            @click="save()"
            :loading="loading"
            :disabled="!isValid"
          >Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import { Vue, Component, Watch } from "vue-property-decorator";
import common from "@/store/common/module/common";
import { doPost } from "@/store/common/module/apis";
import corpService from "@/store/common/module/CorpService";

@Component({
  name: "TariffCategoryCreate",
  props: {
    showDialog: {
      default: false,
    },
    label: {
      default: "Tariff Category Create",
    },
  },
})
export default class TariffCategoryCreate extends Vue {
  name = "TariffCategoryCreate";
  isValid = true;
  tariffCategoryPOSO = {
    _id: null,
    name: "",
    corp_id: null,
  };
  tariffCategory = this.tariffCategoryPOSO;
  path = "";
  leftColStyles = {};
  dialog = false;

  hideMe() {
    this.$emit("dialogUpdate", false);
  }

  get loading() {
    return common.loading;
  }

  validationrules = {
    name: [(v) => !!v || this.$i18n.t("Name is required")],
  };

  @Watch("showDialog")
  onShowDialogChange(val) {
    this.dialog = val;
  }

  closeDialog() {
    this.dialog = false;
    this.$emit("select", null);
  }

  async save() {
    try {
      common.setLoading(true);
      this.tariffCategory = await doPost(
        "/api/rates/category/new",
        this.tariffCategory
      );
      common.setLoading(false);
      common.showMessage("Saved Successfully");
      corpService.clearTariffCategories();
      this.$emit("select", {
        name: this.tariffCategory.name,
        _id: this.tariffCategory._id,
      });
      this.tariffCategory = this.tariffCategoryPOSO;
      this.dialog = false;
    } catch (e) {
      common.setError(e.message);
      common.setLoading(false);
    }
  }
}
</script>
